import { html } from "../../render";
import { attr, cn, safeRandomId, spreadAttrs } from "../../utils";
export const LP_CARD_PADDING = ["none", "base"];
const cardManagedAttrs = [
    "data-lp-component",
    "class",
    "aria-labelledby",
    "aria-describedby",
    "data-padding",
];
export function LpCard({ title, description, actions, children, footer, padding = "base", className, attributes, }) {
    const id = safeRandomId();
    const titleId = title ? `lp-card-title-${id}` : undefined;
    const descriptionId = description ? `lp-card-description-${id}` : undefined;
    const hasHeader = title || description || actions;
    return html `
        <section
            data-lp-component="Card"
            class="${cn("lp-card", className, attributes?.class)}"
            ${attr("data-padding", padding)}
            ${attr("aria-labelledby", titleId)}
            ${attr("aria-describedby", descriptionId)}
            ${spreadAttrs(attributes, { omit: cardManagedAttrs })}
        >
            ${hasHeader
        ? html `
                    <header class="lp-card_header">
                        <div class="lp-card_heading">
                            ${title
            ? html `<h2 class="lp-card_title" id="${titleId}">${title}</h2>`
            : ""}
                            ${description
            ? html `
                                    <p class="lp-card_description" id="${descriptionId}">
                                        ${description}
                                    </p>
                                `
            : ""}
                        </div>
                        ${actions ? html `<div class="lp-card_actions">${actions}</div>` : ""}
                    </header>
                `
        : ""}
            <div class="lp-card_body">${children}</div>
            ${footer ? html `<footer class="lp-card_footer">${footer}</footer>` : ""}
        </section>
    `;
}
